import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_CONVERSATION_ID_BY_THREAD_ID = createAsyncActionTypes('FETCH_CONVERSATION_ID_BY_THREAD_ID');
export const FETCH_ZORSE_INBOXES = createAsyncActionTypes('FETCH_ZORSE_INBOXES');